import { useEffect } from "react";
import { UseData } from "../../../lib/services/UseData";

export function useGetStripeBillingUrl(isUserPremium: boolean) {
	const {
		data: billingUrl,
		error: errorFetchBillingUrl,
		execute: getBillingUrl,
	} = UseData.create().useGetStripeBillingUrl();

	useEffect(() => {
		if (!isUserPremium) return;

		getBillingUrl(typeof window !== "undefined" ? window.location.origin : "");
	}, [getBillingUrl, isUserPremium]);

	return {
		billingUrl,
		errorFetchBillingUrl,
	};
}
